import { MediumContent } from './medium-content.interface'

export const hasVideoDescription = (desc: boolean, isBanner: boolean, item: MediumContent): boolean => {
  return desc && !isBanner && item.type === 'video' && !!item.description_plain
}

export const isEventWithStartDate = (startDate: string | undefined, type: string): boolean => {
  return startDate !== undefined && type === 'event'
}

export const isEventWithPublishDate = (dateToRender: string | undefined, type: string): boolean => {
  return dateToRender !== undefined && type !== 'event'
}

export const showPreviewText = (desc: boolean, previewText: string | undefined | null): boolean => {
  return !!desc && !!previewText
}
